module.exports = __webpack_public_path__ + "static/media/Building A-1-Meter_DB-EA.2bfd74e8.jpg";